import Form from 'vform'
export default function ({ $axios }) {
    Form.axios = $axios
}
